import { Component, OnDestroy, OnInit, inject, input } from '@angular/core';
import { BoDialogComponent } from '@3ddv/software-division-components/backoffice/dialog';
import { ButtonComponent } from '@3ddv/software-division-components/generic/button';
import { InfoGridComponent } from '@3ddv/software-division-components/backoffice/info-grid';
import { BrnDialogRef } from '@spartan-ng/brain/dialog';
import { Subscription } from 'rxjs';
import { LoaderService } from '../../../../core/services/loader.service';
import { DialogCloseReason } from '../../../layout/dialog/app-dialog.service';
import { Adlink } from '../../models/adlink.model';
import { AdlinkService } from '../../services/adlink.service';

@Component({
  selector: 'app-delete',
  templateUrl: './delete.component.html',
  styleUrls: ['./delete.component.css'],
  imports: [BoDialogComponent, ButtonComponent, InfoGridComponent],
})
export class DeleteComponent implements OnInit, OnDestroy {
  private dialogRef = inject<BrnDialogRef<DialogCloseReason>>(BrnDialogRef);
  private adlinkService = inject(AdlinkService);
  private loader = inject(LoaderService);

  readonly id = input.required<number | string>();

  public data: Adlink;
  private subscriptions: Array<Subscription>;
  private waitingapi: boolean;
  constructor() {
    this.subscriptions = [];
    this.waitingapi = false;
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach(o => o.unsubscribe());
  }
  ngOnInit(): void {
    let id = this.id();
    console.log(id);
    if (typeof id === 'string') {
      id = parseInt(id);
    }
    if (typeof id === 'number') {
      const g$ = this.loader.track(this.adlinkService.get$(id)).subscribe({
        next: response => {
          this.data = response.data;
          console.log(this.data);
        },
        error: err => {
          console.log(err);
        },
      });
      this.subscriptions.push(g$);
    }
  }
  public onDismiss(reason: DialogCloseReason) {
    this.dialogRef.close(reason);
  }

  public onConfirm(id: number) {
    if (this.waitingapi) return;
    this.waitingapi = true;
    this.adlinkService.delete$(id).subscribe({
      next: response => {
        this.onDismiss('success');
      },
      error: err => {
        console.log(err);
      },
    });
  }
}
